import React from "react";
import { ConfirmDialog } from "components/shared/ConfirmDialog";

interface DevicesConfirmDialogProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  type: "firmware" | "nipper";
  deviceCount: number;
}

const DevicesConfirmDialog: React.FC<DevicesConfirmDialogProps> = ({
  visible,
  onHide,
  onConfirm,
  isLoading,
  type,
  deviceCount,
}) => {
  const label = type === "firmware" ? "firmware" : "nipper";
  const plural = deviceCount > 1 ? "s" : "";

  return (
    <ConfirmDialog
      visible={visible}
      onHide={onHide}
      onConfirm={onConfirm}
      isProcessing={isLoading}
      title={`Confirm ${type === "firmware" ? "Firmware" : "Nipper"} Update`}
      message={`Are you sure you want to update the ${label} of the ${deviceCount} selected device${plural}?`}
    />
  );
};

export default DevicesConfirmDialog;
